// extracted by mini-css-extract-plugin
export default {"fullscreen":"QhUimS","subscriptionBox":"vSOocE","button":"eaLbGL","title":"NEixoU","description":"yFNgqD","close":"izy2uE"};